import { FETCH_MENU_KEY, TOGGLE_DRAWER_MENU } from "../actionTypes";

const initialState = { 
	menuParentKey: "home",
	menuKey: "home",
	flagDrawerMenu: false
};

const fetchMenuReducer = (state, action) => {
	return {
		...state, 
		menuParentKey: action.menuParentKey, 
		menuKey: action.menuKey
	}
}

const toggleDrawerMenu = (state) => {
	return {
		...state,
		flagDrawerMenu: !state.flagDrawerMenu
	}
}

const leftSideMenu = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_MENU_KEY:
			return fetchMenuReducer(state, action)
		case TOGGLE_DRAWER_MENU:
			return toggleDrawerMenu(state)
		default:
			return state
	}
}

export default leftSideMenu


// WEBPACK FOOTER //
// ./src/store/reducers/leftSideMenu.js